import { ContainerProps } from '@zervant/reactcomponents'
import * as React from 'react'

import { ACTIONS, ActionType } from './Actions'

export class Container<
  Properties = {
    [key: string]: any
  },
> extends React.Component<Properties & { automation?: string } & ContainerProps<typeof ACTIONS> & ActionType, any> {
  public navigate(path: string) {
    this.props.NAVIGATE({ ...this.props.navigation, path })
  }
}
